import { PERSONAL_DATA } from "../../common/constants";
import { GET_QUOTE_LIST_SUCCESS, GET_QUOTE_SETTING_LIST_SUCCESS, GET_DIRECT_DEBIT_CONFIGURATION_SUCCESS, UPDATE_QUOTE_OPERATION_DATA, UPDATE_GENERATED_PAYMENT_REF } from "../action-types/quote";

const initialState = {
    quotes: [],
    settings: [],
    directDebit: null,
    generatedPaymentRef: null,
    mbMinimumMonths: 6,
    operation: {
        showGenerateQuotesDialog: false, 
        confirmQuotes: [], 
        fee: null,
        quotePaymentPlan: null,
        selectedPaymentPlanPart: null,
        dialogActiveIndex: 0, 
        selectedQuotePlan: null,
        selectedPaymentMethod: null,
        beginSubscriptionPeriodDay: 0,
        endSubscriptionPeriodDay: 0,
        entity: null,
        nIPC: null,
        nIPCCountry: { code: "Portugal", name: "Portugal" },
        selectedInvoiceData: PERSONAL_DATA
    }
};

const quoteReducer = (state = initialState, action) => {
    switch(action.type) {
        case GET_QUOTE_LIST_SUCCESS:
            return {
                ...state,
                quotes: action.quotes.quotes
            };
        case GET_QUOTE_SETTING_LIST_SUCCESS:
            return {
                ...state,
                settings: action.settings.settings,
                beginSubscriptionPeriodDay: action.settings.beginSubscriptionPeriodDay,
                endSubscriptionPeriodDay: action.settings.endSubscriptionPeriodDay,
                mbMinimumMonths: action.settings.mbMinimumMonths
            };
        case GET_DIRECT_DEBIT_CONFIGURATION_SUCCESS:
            return {
                ...state,
                directDebit: action.directDebit.quote
            };
        case UPDATE_QUOTE_OPERATION_DATA:
            return {
                ...state,
                operation: action.operation
            };
        case UPDATE_GENERATED_PAYMENT_REF:
            return {
                ...state,
                generatedPaymentRef: action.paymentRef
            };
        default:
            return state;
    }
}

export default quoteReducer;